/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  WithdrawalAssetSupportedChainResponse
} from './schema'



export const utxDigitalWithdrawalAssetChains = (
    asset: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WithdrawalAssetSupportedChainResponse>> => {
    return axios.get(
      `/withdrawal/${asset}/chains`,options
    );
  }


export const getUtxDigitalWithdrawalAssetChainsQueryKey = (asset: string,) => [`/withdrawal/${asset}/chains`];

    
export type UtxDigitalWithdrawalAssetChainsQueryResult = NonNullable<Awaited<ReturnType<typeof utxDigitalWithdrawalAssetChains>>>
export type UtxDigitalWithdrawalAssetChainsQueryError = AxiosError<unknown>

export const useUtxDigitalWithdrawalAssetChains = <TData = Awaited<ReturnType<typeof utxDigitalWithdrawalAssetChains>>, TError = AxiosError<unknown>>(
 asset: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxDigitalWithdrawalAssetChains>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxDigitalWithdrawalAssetChainsQueryKey(asset);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxDigitalWithdrawalAssetChains>>> = ({ signal }) => utxDigitalWithdrawalAssetChains(asset, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxDigitalWithdrawalAssetChains>>, TError, TData>(queryKey, queryFn, {enabled: !!(asset), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

